import { useState } from "react"
import { useSelector } from "react-redux";
import AsyncSelect from 'react-select/async';
import { selectTranslations } from "../../../services/i18n/i18nSlice";
import { searchUsers } from "../UsersApi";
import debounce from 'lodash.debounce';
import { toast } from "react-toastify";

export default function AddUserInput(props) {

    const [showInput, setShowInput] = useState(false)
    const [selectedUser, setSelectedUser] = useState(null)
    const t = useSelector(selectTranslations)

    const _loadOptions =  (pattern, callback) => {
        console.log('call');
        searchUsers({
            ...props?.filters || null,
            pattern: pattern
        }).then((r) => 
            callback(r.data)
        ).catch((e)=>
            toast.error(t.error.error_loading)
        )   
    }

    const loadOptions = debounce(_loadOptions,300)

    const handleAddUser = () => {
        props.onAddUser(selectedUser)
    }
    
    return(
            <div className="add_user_input" open={showInput}> 
                {showInput ?
                    <AsyncSelect 
                        loadOptions={loadOptions} 
                        hidden={!showInput}
                        getOptionLabel={u => `${u.is_admin ? "Admin -" : ""} ${u.email} - ${u.firstname} ${u.lastname}`}
                        getOptionValue={u => u.user_id}
                        className="addUserSelect"
                        classNamePrefix="addUserSelect"
                        onChange={setSelectedUser}
                        isOptionDisabled={u => props?.invalidUsers?.includes(u.user_id)}
                    /> : "" }   
                {showInput ? 
                    <button onClick={handleAddUser} disabled={!selectedUser}>
                        {props.label}
                    </button>
                :
                    <button onClick={()=>{setShowInput(!showInput)}}>
                        {props?.label}
                    </button>
                }
                
            </div>
    )

}